import type { SVGProps } from 'react';
const SvgArrowSmallRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="m6 4 3.92 3.812A.27.27 0 0 1 10 8a.26.26 0 0 1-.08.188L6 12"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgArrowSmallRight;
